import { LazyWrapper } from 'app/view/react_components/lazy/lazy_wrapper';
import React from 'react';
import { Provider } from "react-redux";
import { CardDetailsBaseView } from './base';

export const LinkCardDetailsView = CardDetailsBaseView.extend({

    initialize: function (options) {
        CardDetailsBaseView.prototype.initialize.call(this, options);
        this.cardId = options.cardId;
        this.boardId = options.boardId;
    },

    asideClassName: 'card-link',

    reactRender: function () {
        const ImportElement = React.lazy(() =>
            this.initStore()
                .then(() => import(/* webpackChunkName: "cardDetails" */ '../../react_components/linkCard/hocs/LinkCardHOC/LinkCardHOC'))
                .then(module => ({default: module.LinkCardHOC}))
                .catch(e => console.error(e))
        );

        this.root.render(
            <LazyWrapper>
                <Provider store={this.store}>
                    <ImportElement
                        cardId={this.cardId}
                        boardId={this.boardId}
                    />
                </Provider>
            </LazyWrapper>
        );
    }

});
